import * as React from 'react';
import { Box, Card, CardHeader, List } from '@mui/material';
import { PendingOrder } from './PendingOrder';

const API_URL = import.meta.env.VITE_API_URL;
const limit = 7;

const PendingOrders = () => {
  const [orders, setOrders] = React.useState<any[]>([]);
  const [page, setPage] = React.useState(1);
  const [total, setTotal] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [animKey, setAnimKey] = React.useState(0);

  const loadOrders = async (pageNum: number) => {
    setLoading(true);

    const res = await fetch(
      `${API_URL}/orders?isNew=true&page=${pageNum}&limit=${limit}`,
    );

    const json = await res.json();

    setOrders(json.data || []);
    setTotal(json.total || 0);

    setLoading(false);
  };

  React.useEffect(() => {
    loadOrders(page);
    setAnimKey((k) => k + 1);
  }, [page]);

  const hasNext = page * limit < total;
  const hasPrev = page > 1;

  return (
    <Card sx={{ flex: 1 }}>
      <CardHeader title="Нові замовлення" />

      <Box
        key={animKey}
        sx={{
          minHeight: 500,
          display: 'flex',
          flexDirection: 'column',
          animation: 'fadeSlide 220ms ease-out',
          '@keyframes fadeSlide': {
            from: {
              opacity: 0,
              transform: 'translateY(6px)',
            },
            to: {
              opacity: 1,
              transform: 'translateY(0)',
            },
          },
        }}
      >
        {orders.length > 0 && (
          <List dense sx={{ flex: 1 }}>
            {(orders || []).map((order) => (
              <PendingOrder key={order.orderId} order={order} />
            ))}
          </List>
        )}

        {orders.length === 0 && (
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 14,
            }}
          >
            Немає нових замовлень
          </Box>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            p: 1,
            fontSize: 14,
            cursor: 'pointer',
            minHeight: 40,
          }}
        >
          <Box
            onClick={() => hasPrev && setPage((p) => p - 1)}
            sx={{
              opacity: hasPrev ? 1 : 0,
              pointerEvents: hasPrev ? 'auto' : 'none',
              mx: 1,
            }}
          >
            Повернутись назад
          </Box>

          <Box
            onClick={() => hasNext && setPage((p) => p + 1)}
            sx={{
              opacity: hasNext ? 1 : 0,
              pointerEvents: hasNext ? 'auto' : 'none',
              mx: 1,
            }}
          >
            Переглянути ще
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default PendingOrders;
